<template>
  <div id="app">
    <!--
    <link
      rel="stylesheet"
      type="text/css"
      href="https://dgm.de/typo3temp/assets/css/7015c8c4ac.css?1626692438"
      media="all"
    />
    <link
      rel="stylesheet"
      type="text/css"
      href="https://dgm.de/typo3conf/ext/dgm/Resources/Public/Css/app.css?1633595887"
      media="all"
    />
    <link
      rel="stylesheet"
      type="text/css"
      href="https://dgm.inventum.de/api/conference/eventInformation/170ba699-dfb1-4661-9aea-93ce19fc2244/style.css"
      media="all"
    />
    <link
      rel="stylesheet"
      type="text/css"
      href="https://assets-inventum.ams3.cdn.digitaloceanspaces.com/css/fonts.css"
      media="all"
    />
    -->
    <link
        rel="stylesheet"
        type="text/css"
        :href="'https://'+this.domain+'/api/conference/eventInformation/'+entity+'/style.css'"
        media="all"
    />

    <ConferenceSchedule :entity="entity" :domain="domain"
      :program="program"
      add-top-menu-class="top-16"
      :selected-date="selectedDate" :auto-scroll="autoScroll"
    />
    <GlobalLoader />
  </div>
</template>

<script>
/*eslint no-undef: 0*/
/* eslint-disable */
// eslint-disable-next-line
import ConferenceSchedule from "./components/ConferenceSchedule.vue";

import GlobalLoader from "./../../../../components/public/conference/Global-Loader.vue";

export default {
  name: "ScheduleWidget",
  store: window.chatStore,

  components: {
    ConferenceSchedule, GlobalLoader
  },

  props:{
    id: {
      type: String,
      default: null
    },
    domain: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    autoScroll:
    {
      type: Boolean,
      default: false
    },
    hash: {
      type: String,
      default: null
    },
    entity: {
      type: String,
      default: null
    }
  },
  computed: {
    dateMenu() {
      if (!this.program || !this.program.dates) {
        return {};
      }

      var result = {};
      for (var key in this.program.dates) {
        if (this.program.eventItems && this.program.eventItems[key]) {
          if (this.program.dates[key]) {
            var add = false;
            for (let item2 in this.program.dates[key]) {
              console.log(
                "[PROGRAM DATES]",
                item2,
                this.program.dates[key][item2].event_room_id
              );
              if (
                !add &&
                this.program.dates[key][item2] &&
                this.program.rooms[
                  this.program.dates[key][item2].event_room_id
                ] &&
                !this.program.rooms[
                  this.program.dates[key][item2].event_room_id
                ].hidden
              ) {
                add = true;
              }
            }
            if (add) {
              result[key] = this.program.dates[key];
            }
          }
        }
      }
      return result;
    },
  },
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
      program: {},
      eventData:{},
      timeRangeLength: [],
      selectedDate: null,
      addMinutes: 1,
    };
  },
  methods: {
    getDateObject(dateString) {
      return window.moment(dateString, "YYYY-MM-DD");
    },

    getConferenceSchedule() {
      window.conferenceBus.globalLoading = true;
      var lang="de"

      if(window.appSettings && window.appSettings.appLanguage){
        lang=window.appSettings.appLanguage
      }

      window.widgetDomain=this.domain;

      axios.get('https://'+this.domain + '/api/customer/widget/'+this.id + '/' + this.hash+"?lang="+lang)
        .then((response) => {
          let program=response.data;
           let eventItems=[]
                    _.forEach(response.data.eventItems,(item)=>{
                        _.forEach(item,(item2)=>{
                           
                            _.forEach(item2,(item3)=>{
                                eventItems.push(item3)
                            
                            })
                        })
                    })
                   program['eventItems_all']=eventItems 
          this.program = program;
          this.$store.commit("setProgram", program);
          this.$store.commit("setEventItems", eventItems);
          window.conferenceBus.globalLoading = false;
        })
        .catch((error) => {

            console.log(error);

            setTimeout(() => {
              this.getConferenceSchedule();
            }, 8000);


        });


    },
  },
  created() {
    window.conferenceBus={globalLoading: false};

  },
  mounted() {


    let recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute('src', '//cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.5/MathJax.js?config=TeX-MML-AM_CHTML')
    document.head.appendChild(recaptchaScript)

    this.getConferenceSchedule();

    setTimeout(() => {
      MathJax.Hub.Config({
        messageStyle: "none",
        tex2jax: {
          inlineMath: [
            ["$", "$"],
            ["\\(", "\\)"],
          ],
        },
      });
      MathJax.Hub.Queue(["Typeset", MathJax.Hub]);
    }, 500);
  },
};
</script>

<style></style>
